<div class="modal modal_full-height">
    <span class="modal__close" matDialogClose>
        <i class="material-icons">close</i>
    </span>
  <div class="modal-header">
    <div class="form-row">
      <div class="form-col form-col-8">
        <h3 class="modal-header__title">Фінансові послуги недоступні</h3>
      </div>
    </div>
  </div>
  <form class="form-flex pt-1">
    <main class="modal-content">
      <div class="mr-bottom-16 d-flex flex-direction-column">
        <div class="popup-body">
          <mat-icon class="material-icons-outlined icon p-0">block</mat-icon>
          <div>
            ДДоступ сплачувати за посилки та отримувати післяплату призупинено відповідно до
            вимог чинного законодавста про фінансовий моніторинг,
            <a class="link-red link" href="https://novapay.ua/perevirka-viku/" target="_blank">дізнатися більше</a>.
          </div>
        </div>
        <div class="padded-left mr-bottom-16">
          Що зробити, щоб відправити посилку:
          <div class="popup-body">
            Створити ЕН без післяплати та зазначити платником за послуги одержувача
            посилки.
          </div>
          <div>
            Перейти до редагування даних в накладній?
          </div>
        </div>
      </div>
    </main>
    <div class="modal-footer">
      <div class="modal-footer-buttons px-3">
        <div class="modal-footer-buttons__item">
          <button type="button"
                  mat-button
                  (click)="cancel()">
            Ні, скасувати
          </button>
          <button type="button"
                  color="primary"
                  mat-button
                  matDialogClose>
            Так, редагувати
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
